/**
 * Dashboards entry
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 */

/**
 * Attach directives to Application
 *
 * These provide means of presenting dara (like, building charts)
 */
require('./directives');

/**
 * Attach services to Application
 *
 * These services provide for the api access to Resources
 */
require('./services');

/**
 * Attach controllers to Application
 *
 * These bind together application and data from services
 */
require('./controllers');
